// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fIeM","top":"styles_top__3KlID"};